import {
  VuexModule,
  Module,
  MutationAction,
  getModule,
  Mutation,
} from "vuex-module-decorators";
import store from "@/store";

import { AbonentInfoService } from "@/services/api/abonentinfo.service";
import { Abonent } from "../../lib/abonent.type";

@Module({
  dynamic: true,
  store,
  name: "abonentinfo",
  preserveState: localStorage.getItem("vuex") !== null,
})
export class AbonentInfoVuexModule extends VuexModule {
  abonentInfo: Abonent = new Abonent();
  abonentIsLoading: boolean = true;

  @Mutation setAbonentInfoIsLoading(value: boolean) {
    this.abonentInfo = new Abonent();
    this.abonentIsLoading = value;
  }

  @MutationAction
  public async getAbonentInfo(id: string) {
    const abonentInfo = await AbonentInfoService.getAbonentInfo(id);
    const abonentIsLoading = false;
    return { abonentInfo, abonentIsLoading };
  }
}

export const AbonentInfoModule = getModule(AbonentInfoVuexModule);
